import { __rest } from "tslib";
import * as React from 'react';
const RefundContext = React.createContext(null);
export function useRefund() {
    return React.useContext(RefundContext);
}
const RefundProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(RefundContext.Provider, { value: props }, children);
};
export default RefundProvider;
